import React from 'react';
import { Spinner } from 'reactstrap';

// The summary endpoint sends no currency - fall back to the active country's
const activeCurrency = () => {
  try {
    const user = JSON.parse(localStorage.getItem('authUser') || '{}');
    const country = (localStorage.getItem('WEBSITE_COUNTRY') || '').toLowerCase();
    return user?.countryList?.[country]?.currency || '';
  } catch (error) {
    return '';
  }
};

const formatNumber = (value) =>
  value === null || value === undefined || value === ''
    ? '-'
    : Number(value).toLocaleString();

const formatAmount = (value, currency) => {
  if (value === null || value === undefined || value === '') return '-';
  const amount = Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${currency || ''} ${amount}`.trim();
};

const KpiTile = ({ label, value, sub, tone }) => (
  <div className="pf-kpi-cell">
    <div className="pf-kpi-card">
      <div className="pf-kpi-label">{label}</div>
      <div className={`pf-kpi-value ${tone ? `pf-kpi-${tone}` : ''}`}>{value}</div>
      {sub ? <div className="pf-kpi-sub">{sub}</div> : null}
    </div>
  </div>
);

const PaymentFailedOrdersSummary = ({ summary, isLoading }) => {
  if (isLoading) {
    return (
      <div className="pf-kpi-card mb-3 text-center py-3">
        <Spinner size="sm" color="primary" />
        <span className="ms-2 fs-12">Loading summary…</span>
      </div>
    );
  }

  // The KPI bar always renders - with zeroes when nothing matches the filters
  const total = summary?.total ?? 0;
  const converted = summary?.converted ?? 0;
  const notConverted = summary?.not_converted ?? 0;
  const open = summary?.open ?? 0;
  const conversionRate =
    summary?.conversion_rate ??
    (total > 0 ? ((converted / total) * 100).toFixed(1) : 0);
  const attended = summary?.attended;

  return (
    <div className="pf-kpi-row mb-3">
      <KpiTile
        label="Failed Episodes"
        value={formatNumber(total)}
        sub="In current filters"
      />
      <KpiTile
        label="Attended"
        value={formatNumber(attended?.total ?? 0)}
        sub={`${formatNumber(attended?.converted ?? 0)} converted`}
      />
      <KpiTile
        label="Converted"
        value={formatNumber(converted)}
        tone="positive"
        sub="Recovered sales"
      />
      <KpiTile
        label="Not Converted"
        value={formatNumber(notConverted)}
        tone="negative"
        sub="Closed, no sale"
      />
      <KpiTile label="Still Open" value={formatNumber(open)} sub="Awaiting action" />
      <KpiTile
        label="Conversion Rate"
        value={`${conversionRate}%`}
        tone="positive"
        sub="Converted / total"
      />
      <KpiTile
        label="Revenue Recovered"
        value={formatAmount(
          summary?.revenue_recovered ?? 0,
          summary?.currency || activeCurrency(),
        )}
        tone="positive"
        sub="Sum of converted orders"
      />
    </div>
  );
};

export default PaymentFailedOrdersSummary;
